import { computed, inject, Injectable, signal } from '@angular/core';
import { TextService } from '../text/text.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  private textService = inject(TextService)

  services = signal<ServiceResponse>({} as ServiceResponse)
  filtered: boolean = false

  searchQuery = signal<string>('')

  items = computed(() => {
    const sq = this.searchQuery().toLowerCase();
    let results: ServiceType = {}
    
    if( this.services().serviceList ){
      for (const item of this.services().serviceList) {

        const { category, name, description, duration, language, serviceID } = item.service
        const minified: minifyServiceGroup = { category, name, description, duration, serviceID }

        if (language.toUpperCase() === this.textService.language().toUpperCase()) {
          if(!results[language.toUpperCase()])
            results[language.toUpperCase()] = {}
    
          if (!results[language.toUpperCase()][category]) {
            results[language.toUpperCase()][category] = [];
          }

          const isMatchingCategory = sq.trim().length >= 3 && category.toLowerCase().includes(sq.toLowerCase());
          const isMatchingDescription = sq.trim().length >= 3 && description.toLowerCase().includes(sq.toLowerCase());
          const isMatchingTitle = sq.trim().length >= 3 && name.toLowerCase().includes(sq.toLowerCase());

          if (isMatchingCategory || isMatchingDescription || isMatchingTitle)
            this.filtered = true

          if (sq.trim().length < 3 || isMatchingCategory || isMatchingDescription || isMatchingTitle) {
            results[language.toUpperCase()][category].push(minified);
            results[language.toUpperCase()][category] = results[language.toUpperCase()][category].sort((a, b) =>  a.name.localeCompare(b.name))

          } else if (results[language.toUpperCase()][category].length === 0) {
            delete results[language.toUpperCase()][category];  
          }
        }
      }
    }
    return results
  });

  get ServicesName() {
    if (this.items()[this.textService.language().toUpperCase()])
      return  Object.keys(this.items()[this.textService.language().toUpperCase()])

    return []
  }

  ServiceInfo(serviceName: string) {

    if(this.services().serviceList === undefined)
      return {}

    const service = this.services().serviceList.filter( service => service.service.name === serviceName)[0]

    if (service)
      return {
        "staffIds": service.staffIds,
        "duration": service.service.duration,
        "minLeadHours":  service.service.minLeadHours,
        "minLeadMinutes": service.service.minLeadMinutes,
        "maxLeadDays":  service.service.maxLeadDays,
        "preBuffer":  service.service.preBuffer,
        "postBuffer": service.service.postBuffer,
        "timeInterval": service.service.timeInterval,
        "onlyFirstAvailableDate": false,
        "isSelectable": service.service.isSelectable
      }
    else return {"staffIds": '',
        "duration": '',
        "minLeadHours":  '',
        "minLeadMinutes": '',
        "maxLeadDays":  '',
        "preBuffer":  '',
        "postBuffer": '',
        "timeInterval": '',
        "onlyFirstAvailableDate": false,
        "isSelectable": false}
  }

}
